import React from 'react'
import ReusableInput from '../../../components/comman/ReusableInput'
import { FaBuilding, FaIndustry, } from 'react-icons/fa'
import { PhoneNumberField } from '../../../components/comman/PhoneNumberField'
import ReusableSelect from '../../../components/comman/ReusableSelect';
import Line from '../../../assets/svg/Line';
import { styles } from './Style';

function SconedStep({formik={}}) {

    const handlePhoneChange = ({ countryCode, phoneNumber, }) => {
        // Update formik with the phone data structure
        formik.setFieldValue('companyPhone', phoneNumber);
        formik.setFieldValue('companyPhoneCode', countryCode);
    };


    return (
        <div className="form-step position-relative">
            {/* Top Left Red Dot */}
            <div className="position-absolute rounded-circle" style={styles.dont1}/>
            <div className="position-absolute rounded-circle" style={styles.dont2}/>
            {/* Curved Line SVG */}
            <div className="position-absolute" style={styles.lineWrapper}>
                <Line />
            </div>

            <div className="row">
                <div className="col-md-12">
                    <ReusableInput
                        label="Company Name"
                        value={formik.values.companyName}
                        onChange={formik.handleChange}
                        placeholder="Enter your company name"
                        error={formik.touched.companyName && formik.errors.companyName}
                        name="companyName"
                        required
                        icon={<FaBuilding />}
                    />
                </div>
                <div className="col-md-12">
                    <ReusableSelect
                        label="Company Size"
                        value={formik.values.companySize}
                        onChange={formik.handleChange}
                        placeholder="Enter your company size"
                        error={formik.touched.companySize && formik.errors.companySize}
                        name="companySize"
                        required={false}
                        options={
                            [
                                { value: 1, label: "0 - 100", },
                                { value: 2, label: "100 - 500", },
                                { value: 3, label: "500 - 1,000", },
                                { value: 4, label: "1,000 - 5,000", },
                                { value: 5, label: "5,000 - 10,000", },
                                { value: 6, label: "10,000+" },
                            ]
                        }
                    />
                </div>
                <div className="col-md-12">
                    <div className="form-group">
                        <label>
                            Company Phone
                        </label>
                        <PhoneNumberField
                            value={{ countryCode: '', phoneNumber: formik.values.companyPhone }}
                            onChange={handlePhoneChange}
                        />
                    </div>
                </div>
                <div className="col-md-12">
                    <ReusableInput
                        label="Industry"
                        value={formik.values.industry}
                        onChange={formik.touched.industry && formik.handleChange}
                        placeholder="Enter your company phone number"
                        error={formik?.errors?.industry}
                        name="industry"
                        icon={<FaIndustry />}
                    />
                </div>
            </div>
        </div>
    )
}

export default SconedStep